export default __webpack_public_path__ + "static/media/galleryPic.43464673.jpg";